export default "__VITE_ASSET__Caxqw5Va__"